import { Injectable } from '@angular/core';
import { PortalType } from '../models/auth.model';

@Injectable({
	providedIn: 'root'
})
export class PortalDetectionService {
	private readonly PORTAL_CONFIG: Record<string, { company: string; client: string }> = {
		dev: {
			company: 'dev-dbm.dmehospicesolutions.com',
			client: 'dev-client.dmehospicesolutions.com'
		},
		staging: {
			company: 'staging-dbm.dmehospicesolutions.com',
			client: 'staging-client.dmehospicesolutions.com'
		},
		care: {
			company: 'horizon.dove.care',
			client: 'client.dove.care'
		}
	};

	private readonly COMPANY_HOSTS = [
		'localhost:4200',
		'dev-dbm.dmehospicesolutions.com',
		'staging-dbm.dmehospicesolutions.com',
		'horizon.dove.care'
	];

	private readonly CLIENT_HOSTS = [
		'localhost:3000',
		'dev-client.client.dmehospicesolutions.com',
		'staging-client.dmehospicesolutions.com',
		'client.dove.care'
	];

	getCurrentPortal(): PortalType {
		const hostname = window.location.hostname;
		const port = window.location.port;
		const fullHost = port ? `${hostname}:${port}` : hostname;

		if (this.COMPANY_HOSTS.includes(fullHost)) {
			return 'company';
		}

		if (this.CLIENT_HOSTS.includes(fullHost)) {
			return 'client';
		}

		console.warn('Unknown portal host detected:', fullHost);
		return 'company';
	}

	getPortalUrl(portal: PortalType): string {
		const protocol = window.location.protocol;
		const hostname = window.location.hostname;

		if (hostname === 'localhost') {
			const port = portal === 'company' ? '4200' : '3000';
			return `${protocol}//localhost:${port}`;
		}

		const env = this.getCurrentEnvironment();
		return `${protocol}//${this.PORTAL_CONFIG[env][portal]}`;
	}

	shouldRedirect(targetPortal: PortalType): boolean {
		return this.getCurrentPortal() !== targetPortal;
	}

	private getCurrentEnvironment(): string {
		const hostname = window.location.hostname;
		for (const [env, urls] of Object.entries(this.PORTAL_CONFIG)) {
			if (Object.values(urls).includes(hostname)) {
				return env;
			}
		}
		return 'prod';
	}
}
